import { useTranslation } from "react-i18next";

import { Dropdown, DropdownButton, DropdownContent, DropdownItem } from "@aviary";
import { OpenAction } from "@aviary/components/Dropdown";
import { useMegaMenuQuery } from "@clinic/shared/data/queries/CatalogMegaMenuQuery/CatalogMegaMenu.query";
import { l } from "@emerson/locales/i18n";

import * as navStyles from "../Navigation/Navigation.styles";

import { Content } from "./Content/Content";

import * as styles from "./ShopDropdown.styles";

const DROPDOWN_NAME = "Shop";

type Props = {
  toggleCallback: (dropdown: string) => (isOpen: boolean) => void;
  openDropdown: string;
};

const ShopDropdown = ({ toggleCallback, openDropdown }: Props) => {
  const { t } = useTranslation();

  const queryResult = useMegaMenuQuery({
    variables: { kind: "EMERSON" },
  });

  return (
    <Dropdown
      openAction={OpenAction.HOVER}
      isFullHeight
      dropdownPlacement="bottom-start"
      isOpen={openDropdown === DROPDOWN_NAME}
      toggleCallback={toggleCallback(DROPDOWN_NAME)}
    >
      <div css={navStyles.dropdownButtonBorder}>
        <DropdownButton css={navStyles.dropdownButton} data-e2e="emerson-shop-button">
          {t(l.header.Shop.Header)}
        </DropdownButton>
      </div>
      <DropdownContent css={[styles.shopMenuDropdown, navStyles.dropdownContent]}>
        <div css={styles.shopMenuDropdownContent}>
          <DropdownItem noTruncation noStyle>
            <Content queryResult={queryResult} />
          </DropdownItem>
        </div>
      </DropdownContent>
    </Dropdown>
  );
};

export { ShopDropdown };
